import Controller, { OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ThemeService, ThemeTonalRange } from '@philips-internal/oswald-ui-components';
import BaseController from '../BaseController';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { getFoundationDataContext } from '../../app/bootstrap-foundation';
import './index.css';

@Controller({ fragment: 'account-creation-modal', component: 'modal-account-creation' })
export default class AccountCreationModalController extends BaseController {

  @OnMount({ target: 'modal-account-creation' })
  changeTheme(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
  }

  @OnClose({ target: 'modal-account-creation' })
  onCloseModalAccountCreation(): void {
    const { loginContentTonalRange = ThemeTonalRange.BRIGHT } = getFoundationDataContext().getBulkData();
    ThemeService.setContentTonalRange(loginContentTonalRange as ThemeTonalRange);
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }
}
